import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsProps } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import HeaderSales from "../../components/sales/HeaderSales";
import AllSales from "../../components/sales/Tabs/AllSales";
import TabGiftCards from "../../components/sales/Tabs/TabGiftCards";
import TabMemberships from "../../components/sales/Tabs/TabMemberships";
import TabOrders from "../../components/sales/Tabs/TabOrders";
import TabReservations from "../../components/sales/Tabs/TabReservations";
import { getSale } from "../../network/Sales";

const Sales = ({}: any) => {
  const [type, setType] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [searchSales, setSearchSales] = useState<string>("");
  const [isFilter, setIsFilter] = useState<any>({});
  const [dateRange, setDateRange] = useState<any>({
    date_range: { from: "", to: "" },
  });
  const handelChangeDates = (date: any) => {
    setDateRange({
      from: date?.[0] && dayjs(date?.[0]).format("YYYY-MM-DD"),
      to: date?.[1] && dayjs(date?.[1]).format("YYYY-MM-DD"),
    });
  };
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const { data, isLoading } = useQuery(
    ["sales", type, page, dateRange, isFilter, searchSales],
    () =>
      getSale(locationId, {
        type,
        page,
        date_range: dateRange,
        search_term: searchSales,
        status: isFilter.status,
        created_at: isFilter.created_at,
      })
  );

  const items: TabsProps["items"] = [
    {
      key: "",
      label: (
        <div className="text-[#4f5062] text-center w-full flex items-center justify-center">
          <FormattedMessage id="all_sales" defaultMessage="all sales" />
        </div>
      ),
      children: (
        <AllSales
          data={data}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          handelChangeDates={handelChangeDates}
          dateRange={dateRange}
          setSearchSales={setSearchSales}
          searchSales={searchSales}
          setIsFilter={setIsFilter}
          filterType={{ status2: true, dateAdded: true, price: true }}
        />
      ),
    },
    {
      key: "appointments",
      label: (
        <div className="text-[#4f5062] text-center w-full flex items-center justify-center">
          <FormattedMessage id="reservationsTitle" defaultMessage="حجوزات" />
        </div>
      ),
      children: (
        <TabReservations
          data={data?.data}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          handelChangeDates={handelChangeDates}
          dateRange={dateRange}
          setSearchSales={setSearchSales}
          searchSales={searchSales}
          setIsFilter={setIsFilter}
          filterType={{ status2: true, dateAdded: true, price: true }}
        />
      ),
    },
    {
      key: "orders",
      label: (
        <div className="text-[#4f5062] text-center">
          <FormattedMessage id="ordersTitle" defaultMessage="حجوزات" />
        </div>
      ),
      children: (
        <TabOrders
          data={data}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          handelChangeDates={handelChangeDates}
          dateRange={dateRange}
          setSearchSales={setSearchSales}
          searchSales={searchSales}
          setIsFilter={setIsFilter}
          filterType={{ status2: true, dateAdded: true, price: true }}
        />
      ),
    },
    {
      key: "memberships",
      label: (
        <div className="text-[#4f5062] text-center">
          <FormattedMessage id="membershipsTitle" defaultMessage="حجوزات" />
        </div>
      ),
      children: (
        <TabMemberships
          data={data}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          handelChangeDates={handelChangeDates}
          dateRange={dateRange}
          setSearchSales={setSearchSales}
          searchSales={searchSales}
          setIsFilter={setIsFilter}
          filterType={{ status2: true, dateAdded: true, price: true }}
        />
      ),
    },
    {
      key: "gift_cards",
      label: (
        <div className="text-[#4f5062] text-center">
          <FormattedMessage id="giftCardsTitle" defaultMessage="حجوزات" />
        </div>
      ),
      children: (
        <TabGiftCards
          data={data?.data}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          handelChangeDates={handelChangeDates}
          dateRange={dateRange}
          setSearchSales={setSearchSales}
          searchSales={searchSales}
          setIsFilter={setIsFilter}
          filterType={{ status2: true, dateAdded: true, price: true }}
        />
      ),
    },
  ];

  return (
    <>
      <HeaderSales />
      <div className="mt-8 sales">
        <Tabs
          defaultActiveKey="all"
          items={items}
          tabBarStyle={{ margin: 0 }}
          onChange={(e) => {
            setPage(1);
            setType(e);
            setDateRange({});
          }}
        />
      </div>
    </>
  );
};

export default Sales;
